import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { LoanAdjustmentObj } from "../../utils/types";

const initialState: LoanAdjustmentObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAllLoanAdjustmentData = createAsyncThunk(
  "getAllLoanAdjustment",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const loanAdjustmentSlice = createSlice({
  name: "adjustmentReversal",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllLoanAdjustmentData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllLoanAdjustmentData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAllLoanAdjustmentData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default loanAdjustmentSlice.reducer;
